import { userFilterOptions, userReducerMessage } from '../../constants/app.constants';
import { userActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  isChanged: false,
  error: '',
  CheckBackBtn: false,
  registration: {
    message: '',
    success: false,
  },
  usersByPagging: {
    data: {
      pageNo: 1,
    },
    message: '',
  },
  users: {
    data: {},
    message: '',
  },
  userDetails: {
    data: {},
    message: '',
  },
  sendResetLink: {
    data: {},
    message: '',
  },
  userRole: [],
  companies: [],
  filter: {
    [userFilterOptions.Company]: [],
    [userFilterOptions.Status]: [],
    [userFilterOptions.User]: [],
  },
  userNames: {
    data: [],
  },
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.USER_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.USER_FILTER_SUCCESS:
      const { key, values } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          [key]: [...values],
        },
      };
    case ACTION.USER_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTION.USER_START_FETCH:
      return { ...state, loading: true };

    case ACTION.USER_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTION.USER_REMOVE_ERROR:
      return { ...state, loading: false, error: '' };

    case ACTION.USER_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        registration: {
          success: true,
          message: action.payload,
        },
      };

    case ACTION.USER_REGISTRATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        registration: {
          message: '',
          success: false,
        },
      };
    case ACTION.USER_REGISTRATION_CLEAR_STATE:
      return {
        ...state,
        loading: false,
        error: '',
        registration: {
          message: '',
          success: false,
        },
      };
    case ACTION.REMOVE_USER_REGISTRATION_POPUP:
      return {
        ...state,
        loading: false,
        registration: {
          ...state.registration,
          message: '',
        },
      };

    case ACTION.SET_USER_ROLE:
      return {
        ...state,
        loading: false,
        userRole: action.payload,
      };

    case ACTION.REMOVE_USER_ROLE:
      return {
        ...state,
        loading: false,
        userRole: [],
      };

    case ACTION.FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        users: {
          message: '',
          data: action.payload,
        },
      };

    case ACTION.FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: '',
        users: {
          data: action.payload,
          message: '',
        },
      };

    case ACTION.REMOVE_USERS:
      return {
        ...state,
        loading: false,
        error: '',
        users: {
          message: '',
          data: {},
        },
      };

    case ACTION.FETCH_USERS_BY_PAGGINATION:
      return {
        ...state,
        loading: false,
        error: '',
        usersByPagging: {
          data: action.payload,
        },
      };
    case ACTION.UPDATE_USER_SUCCESS_FROM_THREE_DOT_ACTION:
      return {
        ...state,
        loading: false,
        error: '',
        usersByPagging: {
          ...state.usersByPagging,
          message: userReducerMessage.userUpdate,
        },
      };
    case ACTION.DELETE_USER_SUCCESS_FROM_THREE_DOT_ACTION:
      return {
        ...state,
        loading: false,
        error: '',
        usersByPagging: {
          ...state.usersByPagging,
          message: userReducerMessage.userDelete,
        },
      };
    case ACTION.REMOVE_USERS_BY_PAGGINATION:
      return {
        ...state,
        loading: false,
        error: '',
        usersByPagging: {
          data: {},
        },
      };

    case ACTION.FETCH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: {
          ...state.userDetails,
          data: action.payload,
          message: '',
        },
        error: '',
      };

    case ACTION.FETCH_USER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        userDetails: {
          data: {},
          message: action.payload,
        },
        error: '',
      };

    case ACTION.FETCH_USER_GROUP_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: {
          ...state.userDetails,
          groupDetails: action.payload,
        },
        error: '',
      };

    case ACTION.FETCH_USER_GROUP_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTION.REMOVE_USER_DETAILS:
      return {
        ...state,
        loading: false,
        userDetails: {
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.REMOVE_USER_DETAILS_POPUP:
      return {
        ...state,
        loading: false,
        userDetails: {
          ...state.userDetails,
          message: '',
        },
        error: '',
      };

    case ACTION.DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: {
          ...state.userDetails,
          data: { ...state.userDetails.data, isDeleted: true },
          message: userReducerMessage.userDelete,
        },
        error: '',
      };

    case ACTION.DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        userDetails: {
          ...state.userDetails,
          message: '',
        },
        error: action.payload,
      };

    case ACTION.UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: {
          ...state.userDetails,
          message: userReducerMessage.userUpdate,
        },
        error: '',
      };

    case ACTION.UPDATE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        userDetails: {
          ...state.userDetails,
          message: '',
        },
        error: action.payload,
      };
    case ACTION.UPDATE_USER_FAILURE_FROM_THREE_DOT_ACTION:
      return {
        ...state,
        loading: false,
        error: action.payload,
        usersByPagging: {
          ...state.usersByPagging,
          message: '',
        },
      };
    case ACTION.SENDRESETLINK_START_FETCH:
      return { ...state, loading: true };
    case ACTION.FETCH_SENDRESETLINK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        sendResetLink: {
          data: action.payload,
          message: action.payload.data.message,
        },
        error: '',
      };
    case ACTION.REMOVE_SEND_RESET_LINK_DATA_SUCCESS_MESSAGE:
      return {
        ...state,
        sendResetLink: {
          data: {},
          message: '',
        },
      };
    case ACTION.SENDRESETLINK_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.FETCH_SENDRESETLINK_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        sendResetLink: {
          data: {},
          message: '',
        },
        error: action.payload,
      };
    case ACTION.FETCH_USER_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        userNames: {
          data: action.payload,
        },
      };
    case ACTION.FETCH_USER_NAMES_FAILURE:
      return {
        ...state,
        loading: false,
        userNames: {
          data: [],
        },
      };
    case ACTION.GET_USER_BACKBTN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: true,
      };
    case ACTION.GET_USER_BACKBTN_FAILURE:
      return {
        ...state,
        loading: false,
        error: '',
        CheckBackBtn: false,
      };
    default:
      return state;
  }
};

export default UserReducer;
